// src/emptyStates/EmptyModuleLight.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var EmptyModuleLight = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    fill: "none",
    height: "1em",
    viewBox: "0 0 150 150",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M75 150c41.421 0 75-33.579 75-75S116.421 0 75 0 0 33.579 0 75s33.579 75 75 75z",
          fill: "#EEEFF1"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M120 146a4 4 0 01-4 4H34a4 4 0 01-4-4V56.995c0-2.207 1.815-3.948 3.954-4.495A16.016 16.016 0 0045.5 40.954C46.047 38.815 47.788 37 49.995 37h49.996c2.213 0 3.956 1.824 4.503 3.967a15.885 15.885 0 004.197 7.34 15.89 15.89 0 007.341 4.199c2.144.547 3.968 2.29 3.968 4.503V146z",
          fill: "#F5F5F6"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M75 102c13.255 0 24-10.745 24-24S88.255 54 75 54 51 64.745 51 78s10.745 24 24 24z",
          fill: "#E0E2E6"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M84.546 88.253a1.5 1.5 0 01-2.121 0L76.06 81.89a1.5 1.5 0 00-2.122 0l-6.364 6.364a1.5 1.5 0 01-2.12 0l-.708-.707a1.5 1.5 0 010-2.121l6.364-6.364a1.5 1.5 0 000-2.122l-6.364-6.363a1.5 1.5 0 010-2.122l.707-.707a1.5 1.5 0 012.121 0l6.364 6.364a1.5 1.5 0 002.122 0l6.364-6.364a1.5 1.5 0 012.12 0l.708.707a1.5 1.5 0 010 2.122l-6.364 6.364a1.5 1.5 0 000 2.12l6.364 6.365a1.5 1.5 0 010 2.121l-.707.707z",
          fill: "#F1F1F3"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M88 108H62a3 3 0 100 6h26a3 3 0 100-6zM97 120H53a3 3 0 100 6h44a3 3 0 100-6z",
          fill: "#E0E2E6"
        }
      )
    ]
  }
);
var EmptyModuleLight_default = EmptyModuleLight;

export {
  EmptyModuleLight,
  EmptyModuleLight_default
};
